module.exports = __webpack_public_path__ + "media/images/flags/64/Faroes-c94cfdaab633da511752d91bbb642f1c.png";